<template>
  <div v-if="this.$route.path!=='/pay'">
    <div class="footer-area">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="footer-box about-widget">
              <h2 class="widget-title">友情链接</h2>
              <ul>
                <li>
                  <a href="https://www.dreamlu.net/">
                    <span>如梦技术</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">一流的互联网技术团队</span>
                </li>
                <li>
                  <a href="https://avuejs.com">
                    <span>Avue.js</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">配置化前端框架</span>
                </li>
                <!--<li>
                  <a href="https://www.yybxs.cn/">
                    <span>运营百晓生</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">共享运营可能</span>
                </li>-->
                <li>
                  <a href="https://gitee.com">
                    <span>码云 Gitee</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">云端软件开发协作平台</span>
                </li>
                <li>
                  <a href="https://sns.bladex.cn/">
                    <span>Blade 技术社区</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">官方技术交流平台</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="footer-box get-in-touch">
              <h2 class="widget-title">联系我们</h2>
              <ul>
                <li>
                  <a href="#">
                    <span>开源交流群</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">298061704</span>
                </li>
                <li>
                  <a href="#">
                    <span>会员交流群</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">748802498</span>
                </li>
                <li>
                  <a href="#">
                    <span>商务微信</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span"><span style="cursor: pointer;" @click="openWX()">点击查看</span></span>
                </li>
                <li>
                  <a href="#">
                    <span>电子邮箱</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">bladejava@qq.com</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="footer-box about-widget">
              <h2 class="widget-title">开源产品</h2>
              <ul>
                <li>
                  <a href="https://gitee.com/smallc/SpringBlade">
                    <span>SpringBlade</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">微服务快速开发框架</span>
                </li>
                <li>
                  <a href="https://github.com/chillzhuang/blade-tool">
                    <span>BladeTool</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">微服务核心封装包</span>
                </li>
                <li>
                  <a href="https://gitee.com/smallc/Sword">
                    <span>Sword</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">React前端框架</span>
                </li>
                <li>
                  <a href="https://gitee.com/smallc/Saber">
                    <span>Saber</span>
                  </a>
                  <span> - </span>
                  <span class="footer-span">Vue前端框架</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="footer-box about-widget">
              <h2 class="widget-title">商业授权</h2>
              <ul>
                <li>
                  <router-link to="/vip">
                    <span>购买授权</span>
                  </router-link>
                  <span> - </span>
                  <span class="footer-span">知识付费,让你我走的更远</span>
                </li>
                <li>
                  <router-link to="/doc/notice">
                    <span>授权须知</span>
                  </router-link>
                  <span> - </span>
                  <span class="footer-span">购买前请先阅读授权须知</span>
                </li>
                <li>
                  <router-link to="/license">
                    <span>查询授权</span>
                  </router-link>
                  <span> - </span>
                  <span class="footer-span">在线查验商用企业名单</span>
                </li>
                <li>
                  <router-link to="/doc/biz-changelog">
                    <span>更新日志</span>
                  </router-link>
                  <span> - </span>
                  <span class="footer-span">商业版详细更新日志</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div><!-- end footer -->
    <!-- copyright -->
    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <p>Copyrights &copy; 2025 上海布雷德科技有限公司 All Rights Reserved.</p>
          </div>
          <div class="col-lg-6 text-right col-md-12">
            <p>
              <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32041102000998" target="_blank" style="float:right;color:white">苏公网安备 32041102000998号</a>
              <img src="/images/gongan.png" style="float:right;"/>
              <a href="https://beian.miit.gov.cn" target="_blank" style="float:right;color:white">沪ICP备2023009528号-1&nbsp;&nbsp;</a>
            </p>
          </div>
        </div>
      </div>
    </div><!-- end copyright -->
    <el-dialog title="商务微信"
               :visible.sync="wxBox"
               width="450px">
      <div>
        <img src="/images/wx.png" width="100%" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wxBox: false,
    }
  },
  methods: {
    openWX() {
      this.wxBox = true;
    },
  }
};
</script>

<style lang="scss">
.footer-span {
  color: hsla(0, 0%, 100%, .65)
}
</style>
